module.exports = __webpack_public_path__ + "img/left_layout.08a73557.svg";